import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.search";
import "regenerator-runtime/runtime";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import axios from 'axios';
import _ from 'lodash';
import qs from 'query-string'; // ------------------------------

var state = function state() {
  return {
    shop: '',
    menu_list: [],
    recommend_list: [],
    // フードジャンルの定義
    genre: null,
    genres: [{
      id: "kissako",
      name: "喫茶去"
    }, {
      id: "alacarte",
      name: "あらかると"
    }, {
      id: "parfait",
      name: "パフェ"
    }, {
      id: "setmenu",
      name: "セットメニュー"
    }, {
      id: "drink",
      name: "ドリンク"
    }, {
      id: "ice",
      name: "氷"
    }, {
      id: "soft-serve",
      name: "ソフトクリーム"
    }, {
      id: "float",
      name: "フロート"
    }, {
      id: "snack",
      name: "軽食"
    }, {
      id: "zenzai",
      name: "ぜんざい"
    }, {
      id: "gift",
      name: "おみやげ"
    }, {
      id: "set",
      name: "お茶とお菓子セット"
    }, {
      id: "sweets",
      name: "パフェ・スイーツ"
    }, {
      id: "meal",
      name: "お食事"
    }]
  };
}; // ------------------------------


var getters = {
  menuList: function menuList(state) {
    try {
      // 副作用を防ぐため配列を cloneDeep する
      var menu_list = _.cloneDeep(state.menu_list);

      var query = qs.parse(location.search); // routeQuery に genre を持つ場合

      if (query.genre) {
        menu_list = _.filter(menu_list, function (i) {
          if (query.genre === i.genre.basename) {
            return i;
          }
        });
      }

      return menu_list;
    } catch (error) {
      return null;
    }
  },
  menuListAll: function menuListAll(state) {
    try {
      return state.menu_list;
    } catch (error) {
      return [];
    }
  },
  recommendList: function recommendList(state) {
    try {
      // 取得した全メニューのうち、おすすめの ID が一致したものを抽出
      var menus = _.filter(state.menu_list, function (i) {
        if (_.includes(state.recommend_list, i.id)) {
          return i;
        }
      });

      return menus;
    } catch (error) {
      return [];
    }
  },
  basenameList: function basenameList(state) {
    try {
      var basenames = [];

      _.map(state.menu_list, function (i) {
        basenames.push(i.genre.basename);
      });

      basenames = _.uniq(basenames);
      return basenames;
    } catch (error) {
      return null;
    }
  },
  hasEntryGenre: function hasEntryGenre(state, getters) {
    try {
      var genres = _.filter(state.genres, function (i) {
        if (_.includes(getters.basenameList, i.id)) {
          return i;
        }
      });

      return genres;
    } catch (error) {
      return null;
    }
  },
  allergyList: function allergyList(state) {
    try {
      // 副作用を防ぐため配列を cloneDeep する
      var menu_list = _.cloneDeep(state.menu_list); // ジャンルごとに分類


      var groupedByGenre = _.groupBy(menu_list, function (i) {
        return i.genre.basename;
      }); // console.log(groupedByGenre);


      return groupedByGenre;
    } catch (error) {
      return [];
    }
  }
}; // ------------------------------

var mutations = {
  resetMenuList: function resetMenuList(state) {
    state.menu_list = null;
  },
  setMenuList: function setMenuList(state, payload) {
    // 生の api の結果を state に登録
    state.menu_list = payload.menus;
  },
  setRecommendList: function setRecommendList(state, payload) {
    state.recommend_list = payload.recommends[0].articles;
  },
  setShop: function setShop(state, payload) {
    state.shop = payload;
  },
  setGenre: function setGenre(state, payload) {
    state.genre = payload;
  }
}; // ------------------------------

var actions = {
  getMenuList: function () {
    var _getMenuList = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(_ref, store) {
      var commit, state, _ref2, data;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit, state = _ref.state;
              _context.prev = 1;
              commit('resetMenuList');
              _context.next = 5;
              return axios.get("/api/shop/".concat(store, "/menus.json"));

            case 5:
              _ref2 = _context.sent;
              data = _ref2.data;
              commit('setMenuList', data);
              commit('setShop', store);
              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](1);
              console.error("Error! HTTP states: ".concat(_context.t0));

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 11]]);
    }));

    function getMenuList(_x, _x2) {
      return _getMenuList.apply(this, arguments);
    }

    return getMenuList;
  }(),
  getRecommendList: function () {
    var _getRecommendList = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2(_ref3, store) {
      var commit, state, _ref4, data;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref3.commit, state = _ref3.state;
              _context2.prev = 1;
              _context2.next = 4;
              return axios.get("/api/shop/".concat(store, "/recommends.json"));

            case 4:
              _ref4 = _context2.sent;
              data = _ref4.data;
              commit('setRecommendList', data);
              _context2.next = 12;
              break;

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](1);
              console.error("Error! HTTP states: ".concat(_context2.t0));

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 9]]);
    }));

    function getRecommendList(_x3, _x4) {
      return _getRecommendList.apply(this, arguments);
    }

    return getRecommendList;
  }(),
  setGenre: function () {
    var _setGenre = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee3(_ref5, genre) {
      var commit, stringified, next;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit = _ref5.commit;

              try {
                stringified = qs.stringify({
                  genre: genre
                }); // 取得したジャンルをクエリの形式に変換

                next = "".concat(location.pathname); // genre が指定されたらクエリ付きのパスネームを設定

                if (genre) {
                  next = "".concat(location.pathname, "?").concat(stringified);
                } // console.log(stringified);
                // console.log(next);
                // URL に（クエリ付きの）パスネームをセット


                window.history.pushState(null, null, next);
                commit('setGenre', genre);
              } catch (error) {
                console.log(error);
              }

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    function setGenre(_x5, _x6) {
      return _setGenre.apply(this, arguments);
    }

    return setGenre;
  }()
}; // ------------------------------

export default {
  namespaced: true,
  state: state,
  actions: actions,
  mutations: mutations,
  getters: getters
};